import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import Authentication from "./modules/authentication.module";
import Telemetry from "./modules/telemetry.module";
import Simepar from "./modules/forecasts.module";
import Alerts from './modules/alerts.module';
import Thredds from "./modules/thredds.module";
import Layers from './modules/layers.module';
import Error from './modules/local/error.module';
import WaterSupply from './modules/water_supply.module';
import SearchCache from './modules/search_cache.module';
import Locations from './modules/locations.module';
import Conservation from './modules/conservation.module';
import Envresources from './modules/envresources.module';
import Reports from './modules/reports.module';
import Weather from './modules/weather.module';
import Email from './modules/email.module';
import RainEstimationHistoricalData from './modules/RainEstimationHistoricalData.modules';
import Priv from './modules/priv.module';
import MapMenus from './modules/map_menus.module';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    key: 'vuex',
    storage: window.localStorage,
    modules: ['Authentication',],
});

const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    namespaced : true,
    Authentication,
    Telemetry,
    Simepar,
    Alerts,
    Envresources,
    Thredds,
    Layers,
    Error,
    WaterSupply,
    SearchCache,
    Locations,
    Conservation,
    Reports,
    Weather,
    Email,
    RainEstimationHistoricalData,
    Priv,
    MapMenus,
  },
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  getters: {
    //
  }
});
export default store
